import { EntryGroup, MenuEntry } from './Layout.props';

/**
 * Helper to sort the menu entries according to their parent. The parents on their
 * behalf have to be correctly sorted by the client. The childs are sorted with this
 * logic
 *
 * @param unsortedEntries The clientside unsorted entries for the menu
 * @returns The sorted menu entry array
 */
export const sortMenuEntries = (unsortedEntries: MenuEntry[]): MenuEntry[] => {
  const sortedChilds: Map<string, MenuEntry[]> = unsortedEntries
    .filter((entry) => !!entry.parentId)
    .reduce((map, entry) => {
      const currentEntries: MenuEntry[] = map.get(entry.parentId!) || [];
      currentEntries.push(entry);
      currentEntries.sort((entry1, entry2) => entry1.childPosition! - entry2.childPosition!);
      map.set(entry.parentId!, currentEntries);
      return map;
    }, new Map<string, MenuEntry[]>());
  const parentMenuEntries: MenuEntry[] = unsortedEntries.filter((entry) => !entry.parentId);
  return parentMenuEntries.reduce((targetArray, parent) => {
    return targetArray.concat([parent, ...(sortedChilds.get(parent.id) || [])]);
  }, new Array<MenuEntry>());
};

/**
 * Util method to sort entryGroups by their id
 * @param entryGroups array of entryGroups to sort
 * @returns sorted entryGroups
 */
export const sortEntryGroups = (entryGroups: EntryGroup[]): EntryGroup[] => {
  const sortedGroups: EntryGroup[] = entryGroups.slice().sort((a, b) => (a.id > b.id ? 1 : -1));
  const sortedGroupsAndEntries: EntryGroup[] = sortedGroups.map((group) => ({
    ...group,
    menuEntries: sortMenuEntries(group.menuEntries),
  }));
  return sortedGroupsAndEntries;
};
